// pin icon
export function buildPinIcon(google, { active = false, large = false } = {}) {
	const width = active || large ? 95 : 42;
	const height = active || large ? 141 : 64;

	const svg = active || large
		? `<svg  width="${width}"  height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 ${width} ${height}">
				<path fill="#fff" d="M47.5 119.3 78.7 65a36 36 0 1 0-62.5 0z"/>
				<path stroke="#fff" stroke-opacity=".2" stroke-width="10.4" d="M47.5 5.8a41.3 41.3 0 0 1 35.8 62l-31.3 54-4.5 7.9-4.5-7.8-31.3-54.2c-15.9-27.5 4-62 35.8-62Z"/>
				<path fill="#000" d="M53 52.8h4.6l11 11V51.5L64 46.9H48v21.5l3.7-9zm4.8-13h-4.9v-3.4l-3-3.2-1.8-6.5v19.7h15.3zM31.6 47 27 51.4v12.4l11-11h4.8l1.2 6.6 3.6 9V46.8zm15.9-20.2-1.9 6.5-3 3.2v3.4h-4.8l-5.6 6.6h15.3z"/>
			</svg>`
		: `<svg width="${width}"  height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 ${width} ${height}">
				<path fill="#fff" d="M21 63.3 39 32a20.8 20.8 0 1 0-36 0z"/>
				<path fill="#000" d="M24 25h2.8l6.3 6.4v-7.1l-2.7-2.6h-9.1V34l2-5.1zm2.8-7.4h-2.7v-2l-1.7-1.8-1.1-3.8v11.3H30zm-15 4-2.7 2.7v7l6.4-6.3h2.7l.7 3.8 2 5.2V21.6zM20.9 10l-1 3.8-1.7 1.8v2h-2.8L12 21.3H21z"/>
			</svg>`;

	return {
		url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
		scaledSize: new google.maps.Size(width, height),
		size: new google.maps.Size(width, height),
		origin: new google.maps.Point(0, 0),
		anchor: new google.maps.Point(width / 2, height),
	};
}

// clusters
export function buildClusterRenderer(google, { isDimmed = () => false } = {}) {
	return {
		render: ({ count, position }) => {
			const size = 64;
			const svg = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64">
				<path fill="#fff" d="M8 8h48v48H8z"/>
				<path stroke="#fff" stroke-opacity=".2" stroke-width="8" d="M4 4h56v56H4z"/>
				<text x="50%" y="55%" text-anchor="middle" dominant-baseline="middle" font-family="Arial, sans-serif" font-size="18" font-weight="700" fill="#000"> ${count}
				</text>
			</svg>
			`.trim();
			const dimmed = isDimmed();

			return new google.maps.Marker({
				position,
				icon: {
					url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
					scaledSize: new google.maps.Size(size, size),
					anchor: new google.maps.Point(size / 2, size / 2),
				},
				optimized: false,
				zIndex: 1000 + count,
				opacity: dimmed ? 0.5 : 1,
				clickable: !dimmed,
			});
		},
	};
}